import { getCookie, setCookie, deleteCookie } from 'cookies-next';
import { GetServerSidePropsContext } from 'next';

const cookieOptions = { path: '/' };

type CookieName =
  | 'token'
  // `ps_*` cookies are used for PartnerStack
  | 'ps_xid'
  | 'ps_partner_key'
  | 'blinq_viewer_id';

/**
 * A simple wrapper around `cookies-next`.
 *
 * The request context *must* be provided for server-side operations.
 *
 * @todo figure out the correct expiry to set.
 */
export const cookies = {
  set(name: CookieName, value: string, ctx?: GetServerSidePropsContext): void {
    setCookie(name, value, { ...cookieOptions, req: ctx?.req, res: ctx?.res });
  },
  delete(name: CookieName, ctx?: GetServerSidePropsContext): void {
    deleteCookie(name, { ...cookieOptions, req: ctx?.req, res: ctx?.res });
  },
  get(name: CookieName, ctx?: GetServerSidePropsContext): string | undefined {
    return getCookie(name, ctx);
  },
};
